var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.name !== 'Login')?_c('div',{staticStyle:{"min-height":"60px"}},[_c('top-nav')],1):_vm._e(),_c('v-row',[_c('v-col',{class:{ 'col-sm-12': _vm.$route.name !== 'Login' }},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }